import { getOrderFromBasket } from "../actions/partsActions";
import {
  ADD_ORDER_TO_BASKET,
  ADD_ORDER_TO_BASKET_FAILURE,
  ADD_ORDER_TO_BASKET_SUCCESS,
  BELL_ICON_RESET,
  CONFIRM_ORDER,
  CONFIRM_ORDER_FAILURE,
  CONFIRM_ORDER_SUCCESS,
  GET_ORDER_FROM_BASKET,
  GET_ORDER_FROM_BASKET_FAILURE,
  GET_ORDER_FROM_BASKET_SUCCESS,
  GET_PAST_ORDERS,
  GET_PAST_ORDERS_FAILURE,
  GET_PAST_ORDERS_SUCCESS,
  LOG_OUT,
  REMOVE_ORDER,
  REMOVE_ORDER_FAILURE,
  REMOVE_ORDER_SUCCESS,
} from "../constant";

const initstate = {
  addOrder: {
    success: false,
    message: "",
    error: "",
    isPost: false,
  },
  getOrderFromBasket: {
    success: false,
    orders: [],
    error: "",
    isFetched: false,
    message: "",
  },
  confirmOrder: {
    success: false,
    message: "",
    error: "",
    isPost: false,
  },
  getPastOrder: {
    success: false,
    message: "",
    error: "",
    isFetched: false,
  },
  removeOrder: {
    success: false,
    message: "",
    error: "",
    isPost: false,
  },
  BellIcon: 0,
};
export default function Parts(state = initstate, action) {
  switch (action.type) {
    case ADD_ORDER_TO_BASKET:
      return {
        ...state,
        addOrder: {
          success: false,
          message: "",
          error: "",
          isPost: false,
        },
      };
    case ADD_ORDER_TO_BASKET_SUCCESS:
      let bell = state.BellIcon;
      return {
        ...state,
        addOrder: {
          success: true,
          error: "",
          message: action?.payload?.message,
          isPost: true,
        },
        BellIcon: bell + 1,
      };
    case ADD_ORDER_TO_BASKET_FAILURE:
      return {
        ...state,
        addOrder: {
          success: false,
          error: action?.payload?.error,
          message: "",
          isPost: true,
        },
      };
    case GET_ORDER_FROM_BASKET:
      return {
        ...state,
        getOrderFromBasket: {
          success: false,
          orders: [],
          error: "",
          isFetched: false,
          message: "",
        },
      };
    case GET_ORDER_FROM_BASKET_SUCCESS:
      return {
        ...state,
        getOrderFromBasket: {
          success: true,
          orders: action?.payload?.orders,
          error: "",
          isFetched: true,
          message: action?.payload?.success,
        },
      };
    case GET_ORDER_FROM_BASKET_FAILURE:
      return {
        ...state,
        getOrderFromBasket: {
          success: false,
          orders: [],
          error: action?.payload?.error,
          isFetched: true,
          message: "",
        },
      };
    case CONFIRM_ORDER:
      return {
        ...state,
        confirmOrder: {
          success: false,
          message: "",
          error: "",
          isPost: false,
        },
      };
    case CONFIRM_ORDER_SUCCESS:
      return {
        ...state,
        confirmOrder: {
          success: true,
          message: action?.payload?.message,
          error: "",
          isPost: true,
        },
        getOrderFromBasket: {
          success: false,
          orders: [],
          error: "",
          isFetched: false,
          message: "",
        },
      };
    case CONFIRM_ORDER_FAILURE:
      return {
        ...state,
        confirmOrder: {
          success: false,
          message: "",
          error: action?.payload?.error,
          isPost: true,
        },
      };
    case GET_PAST_ORDERS:
      return {
        ...state,
        getPastOrder: {
          success: false,
          error: "",
          orders: [],
          message: "",
          isFetched: false,
        },
      };
    case GET_PAST_ORDERS_SUCCESS: {
      return {
        ...state,
        getPastOrder: {
          success: true,
          error: "",
          orders: action?.payload?.orders,
          message: action?.payload?.message,
          isFetched: true,
        },
      };
    }
    case GET_PAST_ORDERS_FAILURE: {
      return {
        ...state,
        getPastOrder: {
          success: false,
          orders: [],
          error: action?.payload?.error,
          message: "",
          isFetched: true,
        },
      };
    }
    case REMOVE_ORDER: {
      return {
        ...state,
        removeOrder: {
          success: false,
          error: "",
          message: "",
          isPost: false,
        },
      };
    }
    case REMOVE_ORDER_SUCCESS: {
      let orders = [...state.getOrderFromBasket.orders];
      orders = orders.filter((item, index) => index !== action.payload.id);
      // orders.splice(action.payload.id, 1);
      return {
        ...state,
        removeOrder: {
          success: true,
          error: "",
          message: action?.payload?.message,
          isPost: true,
        },
        getOrderFromBasket: {
          success: false,
          error: "",
          orders: orders,
          message: "",
        },
      };
    }
    case REMOVE_ORDER_FAILURE: {
      return {
        ...state,
        removeOrder: {
          success: false,
          error: action?.payload?.error,
          message: "",
          isPost: true,
        },
      };
    }
    case BELL_ICON_RESET: {
      let bell = state.BellIcon;
      return {
        ...state,
        BellIcon: bell * 0,
      };
    }
    case LOG_OUT:
      return {
        initstate,
      };
    default: {
      return state;
    }
  }
}
